import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ProtectedRoutes from './ProtectedRoutes';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route
            path="/*"
            element={<ProtectedRoutes />}
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
